<script lang="ts" setup>
import RichTextField from '@/components/common/RichTextField.vue';
import MediaList from '@/components/media/MediaList.vue';
import { InfoItem } from '@/models/info-item.model';
import { ref, PropType, watch } from 'vue';

const props = defineProps({
  modelValue: { type: Object as PropType<InfoItem>, required: true },
});

const value = ref<InfoItem>({ ...props.modelValue });

const emit = defineEmits(['update:modelValue']);

const update = () => {
  emit('update:modelValue', value.value);
};

watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);
</script>
<template>
  <v-row>
    <v-col>
      <v-text-field
        v-model="value.title"
        label="Title"
        @change="update"
        required
      ></v-text-field>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <RichTextField
        label="Description"
        v-model="value.description"
        @change="update"
        :media="modelValue.media"
      />
    </v-col>
  </v-row>
  <MediaList v-model="value" @change="update" />
</template>
